import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalCreatePost from '../../pages/home/components/modal.create.post';
import { IPostModel } from '../../models';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import Avatar from '../avatar/avatar.component';

interface CreatePostProps {
  isGroup?: boolean;
  onCreatedSuccess: (newPost: IPostModel) => void;
  profileUser?: boolean;
}

const CreatePost = ({
  onCreatedSuccess,
  isGroup = false,
  profileUser = false,
}: CreatePostProps) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState<boolean>(false);
  const profile = useSelector((state: RootState) => state.features.auth.profile);
  const handleClick = () => {
    if (!profileUser) {
      navigate('/account/login');
      return;
    }
    setVisible(true);
  };

  return (
    <>
      <div
        onClick={handleClick}
        className="bg-white rounded-xl shadow-sm md:p-4 p-2 space-y-4 text-sm font-medium border border-[#DEE0E6] dark:border-slate-700 dark:bg-dark2"
      >
        <div className="flex items-center md:gap-3 gap-2">
          {profile && <Avatar avatar={profile.avatar} label={profile.username} size="sm" />}
          <div
            className="flex-1 flex items-center bg-slate-100 h-10 hover:bg-opacity-80 transition-all rounded-[32px] px-4 py-2 cursor-pointer dark:bg-dark3"
            aria-expanded="false"
          >
            <div className="text-start text-sm dark:text-white">Bạn đang nghĩ gì?</div>
          </div>
          <div
            className="flex items-center p-2 text-[#657384] gap-[10px]  dark:hover:bg-white/20"
            aria-expanded="false"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.58078 19.01L2.56078 19.03C2.29078 18.44 2.12078 17.77 2.05078 17.03C2.12078 17.76 2.31078 18.42 2.58078 19.01Z"
                fill="currentColor"
              />
              <path
                d="M8.99914 10.38C10.3136 10.38 11.3791 9.31443 11.3791 8C11.3791 6.68556 10.3136 5.62 8.99914 5.62C7.6847 5.62 6.61914 6.68556 6.61914 8C6.61914 9.31443 7.6847 10.38 8.99914 10.38Z"
                fill="currentColor"
              />
              <path
                d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 17.28 2.19 18.23 2.56 19.03C3.42 20.93 5.26 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V13.9V7.81C22 4.17 19.83 2 16.19 2ZM20.37 12.5C19.59 11.83 18.33 11.83 17.55 12.5L13.39 16.07C12.61 16.74 11.35 16.74 10.57 16.07L10.23 15.79C9.52 15.17 8.39 15.11 7.59 15.65L3.85 18.16C3.63 17.6 3.5 16.95 3.5 16.19V7.81C3.5 4.99 4.99 3.5 7.81 3.5H16.19C19.01 3.5 20.5 4.99 20.5 7.81V12.61L20.37 12.5Z"
                fill="currentColor"
              />
            </svg>

            <span className="cursor-pointer hover:bg-opacity-80 rounded-xl transition-all  hover:bg-sky-100  dark:hover:bg-white/20">
              Ảnh/Video
            </span>
          </div>
        </div>
      </div>

      {visible && (
        <ModalCreatePost
          onFetch={() => {
            //
          }}
          isOpen={visible}
          reset={() => setVisible(false)}
          onCreatePost={(newPost: IPostModel) => {
            onCreatedSuccess(newPost);
            setVisible(false);
          }}
          isGroup={isGroup}
        />
      )}
    </>
  );
};

export default CreatePost;
